<template>
  <router-link
    :to="{name: toName,
                                                params: {
                                                    itemSlug: item.slug,
                                                    categorySlug: category.slug,
                                                    userSlug: menu.user.slug
                                                }
                                            }"
    v-bind:class="{'not-published':!item.is_published}"
  ><span
      v-if="item.is_new"
      class="badge badge-inverse mb-3 mr-2"
    >NEW</span> <span
      v-if="item.is_popular"
      class="badge mb-3 mr-2"
    ><i class="far fa-heart"></i> POPULAR</span>
    <div class="d-flex itm">
      <div
        class="mr-4 animate__animated animate__fadeIn itm-img-container"
        v-if="item.image"
      >
        <div
          class="itm-img bg-light"
          v-bind:style="{
                                                            'background-image':
                                                                'url(/storage/menu_item_image/' +
                                                                menu.user.id +
                                                                '/medium/' +
                                                                item.image +
                                                                '?v=' +
                                                                item.updated_at +
                                                                ')'
                                                        }"
        >
          <div
            class="cart-count"
            v-if="cartCount && onlineMenuEnabled"
          >{{cartCount}}</div>
        </div>
      </div>
      <div class="flex-grow-1">
        <h2>{{ item.name }} <span
            class="text-warning font-weight-normal small ml-2"
            v-if="!item.is_published"
          >Only you can see this item</span></h2>
        <p
          v-if="item.description"
          class="itm-txt mb-0"
        >
        <pre class="font-family-1 mb-1">{{limitedDescriptionText}}</pre>
        </p>
        <div v-if="item.prices.length">
          <p
            class="mb-0 mb-md-2"
            v-if="!isMobile && !mockMenu"
          >
            <span
              class="mr-4 d-inline-block"
              v-for="(price,index) in item.prices"
              :key="index"
            ><span class="text-muted">{{ price.label }}</span>
              <span>{{
                                                                    menu.user
                                                                        .currency
                                                                        .symbol
                                                                }}{{
                                                                    price.amount | centsToDollars
                                                                }}</span></span>
          </p>
          <p
            class="mb-1"
            v-else
          >
            <span>{{
                                                                    menu.user
                                                                        .currency
                                                                        .symbol
                                                                }}{{
                                                                    itemPriceRangeMin | centsToDollars
                                                                }}</span>

            <span v-if="item.prices.length>1">- {{
                                                                    menu.user
                                                                        .currency
                                                                        .symbol
                                                                }}{{
                                                                    itemPriceRangeMax | centsToDollars
                                                                }}</span>
          </p>
        </div>

        <div
          class="d-flex align-items-center justify-content-between itm-filters"
          v-bind:class="{
                                                            'color-1 mt-2':
                                                                item.is_special
                                                        }"
        >
          <div class="d-flex align-items-center">
            <div
              v-if="
                                                                    item.is_sold_out
                                                                "
              class="small d-inline-block font-weight-bold text-danger mr-2"
            >
              Sold out
            </div>
            <div
              v-if="
                                                                    item.is_special
                                                                "
              class="small d-inline-block text-center"
            >
              <i class="fal fa-tags"></i>
              Special
            </div>
          </div>
          <div class="text-right small text-muted ">
            <div
              v-if="
                                                                    item.is_vegetarian
                                                                "
              class="mr-2 d-none d-lg-inline-block filter-longname"
            >
              <i class="fal fa-carrot"></i>
              Vegeterian
            </div>
            <div
              v-if="
                                                                    item.is_vegan
                                                                "
              class="mr-2 d-none d-lg-inline-block filter-longname"
            >
              <i class="fal fa-seedling"></i>
              Vegan
            </div>
            <div
              v-if="
                                                                    item.is_gluten_free
                                                                "
              class="mr-2 d-none d-lg-inline-block filter-longname"
            >
              <i class="fal fa-wheat"></i>
              Gluten Free
            </div>
            <div
              v-if="
                                                                    item.is_dairy_free
                                                                "
              class="mr-2 d-none d-lg-inline-block filter-longname"
            >
              <i class="fal fa-cow"></i>
              Dairy Free
            </div>
            <div
              v-if="
                                                                    item.is_nut_free
                                                                "
              class="mr-2 d-none d-lg-inline-block filter-longname"
            >
              <i class="fal fa-acorn"></i>
              Nut Free
            </div>

            <div
              v-if="
                                                                    item.is_vegetarian
                                                                "
              class="mr-2 d-lg-none d-inline-block small filter-shortname"
            >
              <i class="fal fa-carrot"></i>
              VG
            </div>
            <div
              v-if="
                                                                    item.is_vegan
                                                                "
              class="mr-2 d-lg-none d-inline-block small filter-shortname"
            >
              <i class="fal fa-seedling"></i>
              V
            </div>
            <div
              v-if="
                                                                    item.is_gluten_free
                                                                "
              class="mr-2 d-lg-none d-inline-block small filter-shortname"
            >
              <i class="fal fa-wheat"></i>
              GF
            </div>
            <div
              v-if="
                                                                    item.is_dairy_free
                                                                "
              class="mr-2 d-lg-none d-inline-block small filter-shortname"
            >
              <i class="fal fa-cow"></i>
              DF
            </div>
            <div
              v-if="
                                                                    item.is_nut_free
                                                                "
              class="mr-2 d-lg-none d-inline-block small filter-shortname"
            >
              <i class="fal fa-acorn"></i>
              NF
            </div>
          </div>
        </div>
      </div>
    </div>
  </router-link>
</template>
<style scoped>
.itm-img {
  position: relative;
}
.cart-count {
  border-radius: 50%;
  text-align: center;
  font-weight: 600;
  color: #fff;
  width: 2rem;
  height: 2rem;
  background-color: var(--user-highlight-color);
  border-color: var(--user-highlight-color);
  font-size: 1rem;
  position: absolute;
  bottom: 0;
  right: 0;
  margin: 0.3rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
<script>
import menuMixin from "../../../mixins/menuMixin";
import accountingMixin from "../../../mixins/accountingMixin";
import cartMixin from "../../../mixins/cartMixin";
export default {
  data() {
    return {
      isMobile: this.isMobileDevice(),
    };
  },
  computed: {
    cartCount() {
      if (this.cartItems) {
        let quantity = 0;
        let _self = this;
        _.forEach(this.cartItems, function (iValue, iKey) {
          if (iValue.id == _self.item.id) {
            _.forEach(iValue.prices, function (pValue, cKey) {
              if (pValue.selected == true) {
                quantity = quantity + iValue.quantity;
              }
            });
          }
        });
        return quantity;
      }
      return false;
    },
    toName() {
      if (this.isMenuOwner) {
        return "menuItemEdit";
      } else {
        return "menuItem";
      }
    },
    limitedDescriptionText: function () {
      if (this.isMobile || this.mockMenu) {
        let len = 50;
        if (!this.item.image) {
          len = 100;
        }
        if (this.item.description.length > len) {
          return this.item.description.substring(0, len) + "...";
        }
      }
      return this.item.description;
    },
    itemPriceRangeMin: function () {
      let maxPrice = Math.min.apply(
        Math,
        this.item.prices.map(function (o) {
          return o.amount;
        })
      );
      return maxPrice;
    },
    itemPriceRangeMax: function () {
      let maxPrice = Math.max.apply(
        Math,
        this.item.prices.map(function (o) {
          return o.amount;
        })
      );
      return maxPrice;
    },
  },
  props: {
    menu: {
      type: Object,
      required: true,
    },
    category: {
      type: Object,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
    mockMenu: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {},
  mixins: [accountingMixin, menuMixin, cartMixin],
};
</script>
